import { listingsAPI } from '../api/client'

type Cached = { data: unknown; at: number }

const CACHE_TTL_MS = 90_000
const cache = new Map<number, Cached>()
const inflight = new Map<number, Promise<unknown>>()

export function getListingCache(listingId: number): unknown | null {
  const hit = cache.get(listingId)
  if (!hit) return null
  if (Date.now() - hit.at > CACHE_TTL_MS) {
    cache.delete(listingId)
    return null
  }
  return hit.data
}

export function setListingCache(listingId: number, data: unknown): void {
  cache.set(listingId, { data, at: Date.now() })
}

/** Warm listing detail before the modal opens (hover / pointer down on card). */
export function prefetchListing(listingId: number): void {
  if (getListingCache(listingId) != null || inflight.has(listingId)) return
  const p = listingsAPI
    .getListing(listingId)
    .then((res) => {
      setListingCache(listingId, res.data)
      return res.data
    })
    .finally(() => {
      inflight.delete(listingId)
    })
  inflight.set(listingId, p)
}
